import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalUserProfile from '../../../../../stores/global-user-profile';

export const startLectureOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
) => {
  try {
    await appApi.startLecture(programId, courseId, lectureId);
    await globalUserProfile.getUserProfile();
    toast.success('ההרצאה החלה בהצלחה');
  } catch (error) {
    console.error('Failed to start lecture:', error);
    toast.error('שגיאה בהתחלת ההרצאה. אנא נסה שוב.');
  }
};
